import { Fade } from "react-awesome-reveal";
import plusIcon from "assets/images/icons/plus.png";
import minusIcon from "assets/images/icons/minus.png";
import { useState } from "react";

const Faqs = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  // faq data
  const faqData = [
    {
      qs: "What IS MamaZen?",
      ans: (
        <p>
            MamaZen is an effective and innovative tool that helps you and your children gain control over your mental and emotional well-being. Our science-based Mindpower Sessions® are based upon the latest research in hypnotherapy, psychology and parenting. All you need is your phone, a few minutes per week, and we do the rest of the work for you.
        </p>
      ),
    },
    {
      qs: "Is this just another meditation app?",
      ans: (
        <p>
            Absolutely not. Let’s be honest, meditation is hard and boring. You won’t need to just sit in silence, trying to quiet your mind. Instead, these are fully guided, hypnotherapy-based Mindpower Sessions that enable you to truly shift your subconscious mind (85% of your mind power!), create new behaviors, break generational cycles & trauma, teach you how to reparent yourself, and empower you to actually become the mom (and person!) you are meant to be.
        </p>
      ),
    },
    {
      qs: "What are Mindpower Sessions?",
      ans: (
        <p>
            Mindpower Sessions® are unique to MamaZen. They are evidence-based sessions that combine the best in hypnotherapy, mindfulness, parenting, and cognitive behavioral psychology. All sessions are created exclusively for MamaZen by renowned clinical hypnotherapist and mindful parenting expert, Jake Y. Rubin, MA, CHT.

            Our Mindpower Sessions help you recognize your emotions and handle them much more positively. You’ll also find that they are a great source of encouragement and support, focused on making you the best mom for your kids.
        </p>
      ),
    },
    {
      qs: `How is this going to help my kids?`,
      ans: (
        <p>
            Our top priority as moms is to raise happy, confident, mindful children who will carry these traits into adulthood. Yet, we haven’t had the tools, until now, to know how to make this happen.

            Our incredible Zenzy® Kids Sessions are unlike anything out there. They will teach your children how to positively regulate their own thoughts and emotions so they can reach their full potential as human beings.
        </p>
      ),
    },
    {
      qs: "What if I have no time?",
      ans: (
        <p>
            We know moms are short on time, which is why we have sessions that are as short as 2 minutes! The longest sessions are only about 20 minutes. You can use them in the morning before the kids wake up, during nap time, or after bedtime.

            You choose when to use the app, just make sure to use it before you lose it… AGAIN :)
        </p>
      ),
    },
    {
      qs: `I’m skeptical. How’s an app going to change my life?`,
      ans: (
        <p>
            We get it. We’d be skeptical too. But there’s a reason why we have won multiple awards and are the #1 Motherhood Wellness app. Because MamaZen actually WORKS -  and it will work for you, and it will change your life. But you have to prioritize using the app.

            It won’t work if you don’t use it.

            That’s why we created recurring reminders and our AI-powered chatbot, which will help guide you to the right session - quickly. Plus, our free trial gives you the opportunity to see for yourself, risk-free.
        </p>
      ),
    },
      {
          qs: `Is there anything for dads?`,
          ans: (
              <p>
                  Of course. Your MamaZen membership includes sessions for your partner in our “Dad’s Zone” section.

                  After listening to these sessions, your partner will be calmer, more helpful, and more patient with the kids as well. In addition, we have some really cool and relaxing Couples Sessions that you and your partner can listen to together.
              </p>
          ),
      },
      {
          qs: `I’m a low-income single mother, how can I apply for a scholarship?`,
          ans: (
              <p>
                  We believe the mental health of moms and kids is a priority, not a privilege. If you are unable to afford our annual or monthly membership, please email us at hello@mamazen.com to request a scholarship application.
              </p>
          ),
      },
      {
          qs: `Why should I start a free trial with MamaZen today?`,
          ans: (
              <p>
                  Starting a free trial with MamaZen lets you test our platform and experience the benefits of our Mindpower Sessions for yourself. With no commitment, you can explore hundreds of expert-led sessions and use any one you like. This risk-free opportunity allows you to make an informed decision about whether MamaZen is right for you.
              </p>
          ),
      },
  ];

  return (
    <div className="faqs_wrapper">
      {/* <Fade triggerOnce delay={700} duration={1600}> */}
        <h3>Frequently Asked Questions</h3>
      {/* </Fade> */}
      <br />
      {faqData.map((data, i) => {
        return (
          <div
            key={i}
            className={`faq_container ${activeFaq === i ? "active_faq" : ""}`}
          >
            <div
              role="button"
              className="faq_qs d_flex align_items_center justify_content_between cursor_pointer user_select_none"
              onClick={() => setActiveFaq((prev) => (prev === i ? null : i))}
            >
              <h6>{data.qs}</h6>
              <span className="faq-arrow">
                {activeFaq === i ? (
                  <img src={minusIcon} alt="" />
                ) : (
                  <img src={plusIcon} alt="" />
                )}
              </span>
            </div>
            <div className="faqs_answer">{data.ans}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Faqs;
